/* ─── aqua-store-locator.js ─────────────────────────────────────────────── */

let map;
let markers = [];
// Store data is now server-rendered inline by snippets/aqua-store-locator-data.liquid
// (from the `store_location` metaobject) — no external fetch, no Apps Script cold-start.
const dataPromise = Promise.resolve(readStoreData());

function readStoreData() {
  const el = document.getElementById("aqua-store-data");
  if (!el) return { ok: false, markers: [] };
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    console.error("Invalid store data JSON", e);
    return { ok: false, markers: [] };
  }
}

async function initMap() {
  const [{ Map, InfoWindow }, { AdvancedMarkerElement }, , data] = await Promise.all([
    google.maps.importLibrary("maps"),
    google.maps.importLibrary("marker"),
    google.maps.importLibrary("places"),
    dataPromise  // already in flight since page load
  ]);
  
  // const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  // const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
  // await google.maps.importLibrary("places");

  map = new Map(document.getElementById("map"), {
    center: { lat: 32.0045821, lng: 34.7401857 }, // Aqua Headquarters
    zoom: 3,
    mapId: "map",
    mapTypeControl: false,
    fullscreenControl: false,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER,
    }
  });

  // Search for a location
  const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement();
  placeAutocomplete.id = 'store-search';
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(placeAutocomplete);

  // If place is selected, center map on it
  placeAutocomplete.addEventListener("gmp-select", async (event) => {
    const place = event.placePrediction.toPlace();
    await place.fetchFields({ fields: ["location", "viewport"] });
    if (place.viewport) {
      map.fitBounds(place.viewport);
    } else {
      map.setCenter(place.location);
      map.setZoom(10);
    }
  });

  // Add "center on my location" button
  const geolocationDiv = document.createElement('div');
  const controlUI = document.createElement('div');
  controlUI.setAttribute('id', 'center-map');
  controlUI.title = 'Use location';
  geolocationDiv.appendChild(controlUI);
  const controlText = document.createElement('div');
  controlText.setAttribute('class', 'button button-unstyled--with-icon');
  controlText.innerHTML = 'Center My Location';
  controlUI.appendChild(controlText);
  controlUI.addEventListener('click', getLocation, false);
  map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(geolocationDiv);

  const infoWindow = new InfoWindow();

  if (!data.ok || !Array.isArray(data.markers)) {
    console.error("Invalid marker payload", data);
    return;
  }

  const bounds = new google.maps.LatLngBounds();

  // Region → country → store name, so both the map order and the side list
  // read alphabetically. Metaobject entry order is arbitrary (import order),
  // and with 34 countries an unsorted list is hard to scan.
  data.markers.sort((a, b) =>
    (a.region || '').localeCompare(b.region || '') ||
    (a.country || '').localeCompare(b.country || '') ||
    (a.name || '').localeCompare(b.name || '')
  );

  data.markers.forEach((item, i) => {
    const icon = document.createElement("div");
    icon.style.cssText = 'width:33px;height:39px';
    icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.22 38.53" width="33" height="39">
      <path d="M16.81,3.88c-7.08,0-12.82,3.84-12.82,12.72s12.82,19.46,12.82,19.46c0,0,12.82-10.57,12.82-19.46S23.89,3.88,16.81,3.88Z" fill="#171717" stroke="#fff" stroke-width="2" stroke-miterlimit="10"/>
    </svg>`;
    
    const marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: { lat: item.lat, lng: item.lng },
      title: item.name,
      content: icon
    });
    
    const address = item.address.replace(/(?:\r\n|\r|\n)/g, '<br>');
    const infoHtml = `
      <div class="store">
        <h3 class="h4">${escapeHtml(item.name)}</h3>
        <p class="text--light">${address}<br/>
          Telephone: ${escapeHtml(item.phone)}<br/>
          Website: <a href="${escapeHtml(item.website)}" target="_blank">${escapeHtml(item.website)}</a><br/>
          Email: ${escapeHtml(item.email)}</p>
      </div>`;
      
    marker.addListener("gmp-click", () => {
      infoWindow.close();
      infoWindow.setContent(infoHtml);
      infoWindow.open({ anchor: marker, map });
    });
    
    markers.push(marker);
    
    createList(i, infoHtml, item.country, item.stores_per_country, item.region);
    
    bounds.extend({ lat: item.lat, lng: item.lng });
  });

  // Clusterer — uses .aqua-clustericon class styled in the CSS
  if (window.markerClusterer) {
    new markerClusterer.MarkerClusterer({
      map,
      markers,
      renderer: {
        render({ count, position }) {
          const size = Math.min(36 + count * 2, 56);
          const div = document.createElement('div');
          div.className = 'aqua-clustericon';
          div.style.width  = size + 'px';
          div.style.height = size + 'px';
          div.textContent  = count;
          return new google.maps.marker.AdvancedMarkerElement({
            position,
            content: div,
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          });
        },
      },
    });
  }

  if (data.markers.length) {
    map.fitBounds(bounds);
  }
}

function createList(id, data, country, count, region) {
  let list = document.getElementById('list');
  let store = document.createElement('div');
  let panel = document.createElement('div');
  let countryID = country.replace(/\s+/g, '-').toLowerCase();
  let regionID  = region.replace(/\s+/g, '-').toLowerCase();

  // Region accordion
  if (!document.getElementById('region-' + regionID)) {
    let regions = list.querySelectorAll('.locator__region-title');
    let regionButton = document.createElement('button');
    let regionSpan = document.createElement('span');
    regionSpan.textContent = region;
    regionButton.setAttribute('id', 'region-' + regionID);
    regionButton.setAttribute('class', 'button button-unstyled locator__region-title accordion');
    regionButton.setAttribute('data-order', regions.length);
    regionButton.style.order = regions.length; // CSS order: attr() isn't supported by any browser
    regionButton.appendChild(regionSpan);

    regionButton.addEventListener("click", function () {
      this.classList.toggle("active");
      let countries = list.querySelectorAll('.locator__country-title.active');
      let elements  = list.querySelectorAll('[data-region="' + regionID + '"]');
      elements.forEach(el => el.classList.toggle("visible"));
      countries.forEach(btn => btn.classList.remove("active"));
    });

    list.appendChild(regionButton);
  }

  // Country accordion + panel
  if (document.getElementById('panel-' + countryID)) {
    panel = document.getElementById('panel-' + countryID);
  } else {
    let countryButton = document.createElement('button');
    let countrySpan   = document.createElement('span');
    let region_title  = document.getElementById('region-' + regionID);
    let order = region_title.getAttribute('data-order');

    countrySpan.textContent = country;
    countrySpan.setAttribute('data-count', count);
    countryButton.setAttribute('class', 'button button-unstyled locator__country-title accordion');
    countryButton.setAttribute('data-region', regionID);
    countryButton.setAttribute('data-order', order);
    countryButton.style.order = order; // CSS order: attr() isn't supported by any browser
    countryButton.appendChild(countrySpan);

    panel.setAttribute('id', 'panel-' + countryID);
    panel.setAttribute('data-region', regionID);
    panel.setAttribute('data-order', order);
    panel.style.order = order; // CSS order: attr() isn't supported by any browser
    panel.classList.add('panel');

    countryButton.addEventListener("click", function () {
      let toggle = this.nextElementSibling;
      if (!this.classList.contains('active')) {
        this.classList.add('active');
        toggle.classList.add('open');
        toggle.style.height = 'auto';
        var height = toggle.clientHeight + 'px';
        toggle.style.height = '0px';
        setTimeout(() => { toggle.style.height = height; }, 0);

        let stores = toggle.querySelectorAll('.place');
        var bounds = new google.maps.LatLngBounds();
        stores.forEach(function (storeDiv) {
          let markerID = storeDiv.getAttribute('data-id');
          bounds.extend(markers[markerID].position);
          map.fitBounds(bounds);
        });
        if (stores.length === 1) map.setZoom(14);

        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      } else {
        this.classList.remove('active');
        toggle.style.height = '0px';
        toggle.addEventListener('transitionend', () => {
          toggle.classList.remove('open');
        }, { once: true });
      }
    });

    list.appendChild(countryButton);
    list.appendChild(panel);
  }

  store.classList.add('place');
  store.setAttribute('data-id', id);
  store.innerHTML = data;
  store.addEventListener('click', function () {
    google.maps.event.trigger(markers[id], 'gmp-click');
    map.setZoom(14);
    map.setCenter(markers[id].position);
  }, false);

  panel.appendChild(store);
}

/* ─── Geolocation ───────────────────────────────────────────────────────────
   getCurrentPosition() with no options defaults to timeout: Infinity, so a
   stalled location provider leaves the button dead with no feedback. Options
   are explicit below, and status is reported inline on the control itself
   rather than through alert() (blocking, and suppressed in some contexts).
   Note: error code 2 (POSITION_UNAVAILABLE) is usually an OS-level setting —
   on macOS, System Settings → Privacy & Security → Location Services.
   ────────────────────────────────────────────────────────────────────────── */
const GEO_OPTIONS = { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 };

function geoStatus(message, isError, hint) {
  const label = document.querySelector('#center-map .button');
  if (!label) return;
  if (!label.dataset.defaultText) label.dataset.defaultText = label.textContent;
  label.textContent = message || label.dataset.defaultText;
  label.classList.toggle('is-error', !!isError);
  label.title = hint || '';
  recenterGeoControl();
  clearTimeout(geoStatus._t);
  if (message) {
    geoStatus._t = setTimeout(() => {
      label.textContent = label.dataset.defaultText;
      label.classList.remove('is-error');
      label.title = '';
      recenterGeoControl();
    }, 5000);
  }
}

/* Maps positions a BOTTOM_CENTER control by writing a fixed `left` offset,
   measured once from the control's width when it was added. Swapping the
   label text changes that width, so the control drifts off-centre and a long
   message can run past the map edge. Removing and re-adding it makes Maps
   re-measure and re-centre. */
function recenterGeoControl() {
  if (typeof map === 'undefined' || !map || !window.google || !google.maps) return;
  const controls = map.controls[google.maps.ControlPosition.BOTTOM_CENTER];
  if (!controls || controls.getLength() === 0) return;
  requestAnimationFrame(() => {
    const el = controls.pop();
    if (el) controls.push(el);
  });
}

function getLocation() {
  const control = document.getElementById('center-map');
  if (!navigator.geolocation) {
    geoStatus('Location not supported', true);
    return;
  }
  if (control && control.dataset.busy === 'true') return;
  if (control) control.dataset.busy = 'true';
  geoStatus('Locating…');
  navigator.geolocation.getCurrentPosition(success, error, GEO_OPTIONS);
}

function success(position) {
  const control = document.getElementById('center-map');
  if (control) control.dataset.busy = 'false';
  map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
  map.setZoom(8);
  geoStatus(null);
}

function error(err) {
  const control = document.getElementById('center-map');
  if (control) control.dataset.busy = 'false';
  // Kept short so the control stays close to its default width; the full
  // explanation goes in the tooltip.
  const messages = {
    1: ['Location blocked', 'Allow location access for this site in your browser settings.'],
    2: ['Location unavailable', 'Your device could not provide a position. Check that location services are switched on.'],
    3: ['Location timed out', 'Your device took too long to respond. Please try again.']
  };
  const [text, hint] = messages[err && err.code] || ['Location unavailable', ''];
  geoStatus(text, true, hint);
}

function escapeHtml(str) {
  return String(str).replace(/[&<>"']/g, (char) => {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
  });
}

window.initMap = initMap;
